/* 🤖 this file was generated by svg-to-ts */
export const iconIconAdd: {
  name: 'icon-add';
  data: string;
} = {
  name: 'icon-add',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"/></svg>`,
};
export const iconIconAddressBook: {
  name: 'icon-address-book';
  data: string;
} = {
  name: 'icon-address-book',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M18 2h2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-2z" opacity=".3"/><path fill="#000" d="M5 2h12a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1m7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-5 5.5c-.011.162.265.5.404.5h9.177c.418 0 .424-.378.418-.5-.163-3.067-2.348-4.5-5.008-4.5-2.623 0-4.775 1.517-4.99 4.5"/></g></svg>`,
};
export const iconIconBooks: {
  name: 'icon-books';
  data: string;
} = {
  name: 'icon-books',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M5 3h1a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1m5 0h1a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/><rect width="3" height="18" x="16.326" y="2.946" fill="#000" opacity=".3" rx="1" transform="rotate(-19 17.826 11.946)"/></g></svg>`,
};
export const iconIconCard: {
  name: 'icon-card';
  data: string;
} = {
  name: 'icon-card',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect width="20" height="14" x="2" y="5" fill="#000" opacity=".3" rx="2"/><path fill="#000" d="M2 8h20v3H2z"/><rect width="4" height="2" x="16" y="14" fill="#000" opacity=".3" rx="1"/></g></svg>`,
};
export const iconIconChartLine1: {
  name: 'icon-chart-line1';
  data: string;
} = {
  name: 'icon-chart-line1',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M5 19h15a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0z"/><path fill="#000" fill-rule="nonzero" d="M8.73 14.684a1 1 0 1 1-1.46-1.368l3.75-4a1 1 0 0 1 1.38-.077l2.959 2.526 3.856-4.885a1 1 0 0 1 1.57 1.24l-4.5 5.7a1 1 0 0 1-1.434.14l-3.024-2.58z" opacity=".3"/></g></svg>`,
};
export const iconIconChat: {
  name: 'icon-chat';
  data: string;
} = {
  name: 'icon-chat',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M16 15.632V12a3 3 0 0 0-3-3H6.162V5.526A2.526 2.526 0 0 1 8.688 3h11.79a2.526 2.526 0 0 1 2.526 2.526v7.58l.017 4.68a.5.5 0 0 1-.854.356l-2.51-2.51z"/><path fill="#000" d="M1.985 18v-5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4.101l-1.244 1.19a.5.5 0 0 1-.846-.36v-2.506A2 2 0 0 1 1.985 18M6.5 14a.5.5 0 1 0 0 1h5a.5.5 0 1 0 0-1zm3 2a.5.5 0 1 0 0 1h2a.5.5 0 1 0 0-1z" opacity=".3"/></g></svg>`,
};
export const iconIconClipboardCheck: {
  name: 'icon-clipboard-check';
  data: string;
} = {
  name: 'icon-clipboard-check',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M8 3v.5A1.5 1.5 0 0 0 9.5 5h5A1.5 1.5 0 0 0 16 3.5V3h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" opacity=".3"/><path fill="#000" d="M10.875 15.75a.95.95 0 0 1-.67-.287l-1.918-1.917a.926.926 0 0 1 0-1.342c.384-.383 1.007-.383 1.342 0l1.246 1.246 3.162-3.162a.926.926 0 0 1 1.342 0 .926.926 0 0 1 0 1.341l-3.833 3.834a.95.95 0 0 1-.671.287M11 2a1 1 0 0 1 2 0h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/></g></svg>`,
};
export const iconIconClipboard: {
  name: 'icon-clipboard';
  data: string;
} = {
  name: 'icon-clipboard',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M8 3v.5A1.5 1.5 0 0 0 9.5 5h5A1.5 1.5 0 0 0 16 3.5V3h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" opacity=".3"/><path fill="#000" d="M11 2a1 1 0 0 1 2 0h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/><rect width="7" height="2" x="10" y="9" fill="#000" opacity=".3" rx="1"/><rect width="2" height="2" x="7" y="9" fill="#000" opacity=".3" rx="1"/><rect width="2" height="2" x="7" y="13" fill="#000" opacity=".3" rx="1"/><rect width="7" height="2" x="10" y="13" fill="#000" opacity=".3" rx="1"/><rect width="2" height="2" x="7" y="17" fill="#000" opacity=".3" rx="1"/><rect width="7" height="2" x="10" y="17" fill="#000" opacity=".3" rx="1"/></g></svg>`,
};
export const iconIconClipboard2: {
  name: 'icon-clipboard2';
  data: string;
} = {
  name: 'icon-clipboard2',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M8 3v.5A1.5 1.5 0 0 0 9.5 5h5A1.5 1.5 0 0 0 16 3.5V3h2a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" opacity=".3"/><path fill="#000" d="M11 2a1 1 0 0 1 2 0h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/><rect width="5" height="2" x="7" y="10" fill="#000" opacity=".3" rx="1"/><rect width="9" height="2" x="7" y="14" fill="#000" opacity=".3" rx="1"/></g></svg>`,
};
export const iconIconClock: {
  name: 'icon-clock';
  data: string;
} = {
  name: 'icon-clock',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M12 22a9 9 0 1 1 0-18 9 9 0 0 1 0 18" opacity=".3"/><path fill="#000" d="M11.963 7.5h.085a.5.5 0 0 1 .497.45L13 12.5l3.248 1.856a.5.5 0 0 1 .252.434V15a.382.382 0 0 1-.482.368l-4.62-1.26a.5.5 0 0 1-.366-.52l.432-5.626a.5.5 0 0 1 .499-.462"/></g></svg>`,
};
export const iconIconCreditCard: {
  name: 'icon-credit-card';
  data: string;
} = {
  name: 'icon-credit-card',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect width="19" height="4" x="2" y="5" fill="#000" rx="1"/><rect width="19" height="10" x="2" y="11" fill="#000" opacity=".3" rx="1"/></g></svg>`,
};
export const iconIconEdit: {
  name: 'icon-edit';
  data: string;
} = {
  name: 'icon-edit',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="m21.748 7.099-8.85 9.215a1.5 1.5 0 0 1-1.05.46l-3.723.079.079-3.738a1.5 1.5 0 0 1 .442-1.033l9.05-8.999a1.5 1.5 0 0 1 2.118.003L21.727 5a1.5 1.5 0 0 1 .021 2.1"/><path fill="#000" fill-rule="nonzero" d="M12.9 2a1 1 0 0 1 0 2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 1 2 0v5a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z" opacity=".3"/></g></svg>`,
};
export const iconIconErrorCircle: {
  name: 'icon-error-circle';
  data: string;
} = {
  name: 'icon-error-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><circle cx="12" cy="12" r="10" fill="#000" opacity=".3"/><path fill="#000" d="m12.036 10.621 2.828-2.828a1 1 0 0 1 1.414 1.414l-2.828 2.829 2.828 2.828a1 1 0 0 1-1.414 1.414l-2.828-2.828-2.829 2.828a1 1 0 1 1-1.414-1.414l2.828-2.828-2.828-2.829a1 1 0 0 1 1.414-1.414z"/></g></svg>`,
};
export const iconIconFolder: {
  name: 'icon-folder';
  data: string;
} = {
  name: 'icon-folder',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M3.5 21h17a1.5 1.5 0 0 0 1.5-1.5v-11A1.5 1.5 0 0 0 20.5 7H10L7.44 4.44A1.5 1.5 0 0 0 6.378 4H3.5A1.5 1.5 0 0 0 2 5.5v14A1.5 1.5 0 0 0 3.5 21" opacity=".3"/></g></svg>`,
};
export const iconIconHappy: {
  name: 'icon-happy';
  data: string;
} = {
  name: 'icon-happy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect width="20" height="20" x="2" y="2" fill="#000" opacity=".3" rx="10"/><path fill="#000" d="M6.168 14.555a1 1 0 0 1 1.664-1.11C8.99 15.181 10.354 16 12 16s3.01-.82 4.168-2.555a1 1 0 1 1 1.664 1.11C16.322 16.819 14.354 18 12 18s-4.322-1.18-5.832-3.445"/></g></svg>`,
};
export const iconIconHeart: {
  name: 'icon-heart';
  data: string;
} = {
  name: 'icon-heart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M16.5 4.5c-1.61 0-3.492 1.825-4.5 3-1.008-1.175-2.89-3-4.5-3C4.651 4.5 3 6.722 3 9.55q0 4.7 9 9.95 9-5.25 9-9.75c0-2.828-1.651-5.25-4.5-5.25"/></g></svg>`,
};
export const iconIconImportant: {
  name: 'icon-important';
  data: string;
} = {
  name: 'icon-important',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><circle cx="12" cy="12" r="10" fill="#000" opacity=".3"/><rect width="2" height="7" x="11" y="10" fill="#000" rx="1"/><rect width="2" height="2" x="11" y="7" fill="#000" rx="1"/></g></svg>`,
};
export const iconIconInfo: {
  name: 'icon-info';
  data: string;
} = {
  name: 'icon-info',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8M11 7h2v6h-2zm0 8h2v2h-2z"/></svg>`,
};
export const iconIconMirror: {
  name: 'icon-mirror';
  data: string;
} = {
  name: 'icon-mirror',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M13 17.048V18h1a2 2 0 0 1 2 2H8a2 2 0 0 1 2-2h1v-.952A8.996 8.996 0 0 1 3.076 9.22a1 1 0 0 1 1.985-.244 6.995 6.995 0 0 0 13.891-.098 1 1 0 0 1 1.989.216A8.995 8.995 0 0 1 13 17.048"/><path fill="#000" d="M12 14a6 6 0 1 1 0-12 6 6 0 0 1 0 12M8.816 7.8a.656.656 0 1 0-1.31.092c.117 1.661.89 2.972 2.289 3.875a.656.656 0 0 0 .712-1.102C9.456 9.985 8.903 9.049 8.816 7.8" opacity=".3"/></g></svg>`,
};
export const iconIconPaperError: {
  name: 'icon-paper-error';
  data: string;
} = {
  name: 'icon-paper-error',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M5.857 2h7.88a1.5 1.5 0 0 1 .968.355l4.764 4.029A1.5 1.5 0 0 1 20 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2" opacity=".3"/><path fill="#000" d="m10.586 13-1.414-1.414a1 1 0 1 1 1.414-1.414L12 11.586l1.414-1.414a1 1 0 1 1 1.414 1.414L13.414 13l1.414 1.414a1 1 0 1 1-1.414 1.414L12 14.414l-1.414 1.414a1 1 0 1 1-1.414-1.414z"/></g></svg>`,
};
export const iconIconQuestionCircle: {
  name: 'icon-question-circle';
  data: string;
} = {
  name: 'icon-question-circle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><circle cx="12" cy="12" r="10" fill="#000" opacity=".3"/><path fill="#000" d="M12 16a1 1 0 1 1 0 2 1 1 0 0 1 0-2m-1.409-1.132v-1.659h1.26c1.596 0 2.751-1.218 2.751-2.814s-1.155-2.814-2.751-2.814c-1.617 0-2.73 1.218-2.73 2.814H7.336c0-2.52 1.974-4.473 4.515-4.473s4.536 1.953 4.536 4.473-1.995 4.473-4.536 4.473z"/></g></svg>`,
};
export const iconIconQuestion: {
  name: 'icon-question';
  data: string;
} = {
  name: 'icon-question',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="currentColor" d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-2a8 8 0 1 1 0-16 8 8 0 0 1 0 16" opacity=".3"/><path fill="currentColor" d="M12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-.5-3.5h1c0-1.25 1-1.75 1.5-2.5s.5-1.75-.25-2.5-2-.75-2.75-.25-1 1.5-1 2.25h1.5c0-.25.25-.75.5-1s.75-.25 1 0 .25.75 0 1-.75.75-1 1.25-.5 1-.5 1.75"/></g></svg>`,
};
export const iconIconReport: {
  name: 'icon-report';
  data: string;
} = {
  name: 'icon-report',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect width="3" height="16" x="13" y="4" fill="#000" opacity=".3" rx="1.5"/><rect width="3" height="11" x="8" y="9" fill="#000" rx="1.5"/><rect width="3" height="9" x="18" y="11" fill="#000" rx="1.5"/><rect width="3" height="7" x="3" y="13" fill="#000" rx="1.5"/></g></svg>`,
};
export const iconIconReturn: {
  name: 'icon-return';
  data: string;
} = {
  name: 'icon-return',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M12 8H8a4 4 0 0 0-4 4v1a3 3 0 0 0 3 3v2a5 5 0 0 1-5-5v-1a6 6 0 0 1 6-6h4V4.728a.5.5 0 0 1 .8-.4l2.856 2.133a.5.5 0 0 1-.001.802l-2.857 2.121A.5.5 0 0 1 12 8.983z"/><path fill="#000" d="M12.058 16H16a4 4 0 0 0 4-4v-1a3 3 0 0 0-3-3V6a5 5 0 0 1 5 5v1a6 6 0 0 1-6 6h-3.942v.983a.5.5 0 0 1-.798.401l-2.857-2.12a.5.5 0 0 1 0-.803l2.856-2.134a.5.5 0 0 1 .8.401z" opacity=".3"/></g></svg>`,
};
export const iconIconSad: {
  name: 'icon-sad';
  data: string;
} = {
  name: 'icon-sad',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><rect width="20" height="20" x="2" y="2" fill="#000" opacity=".3" rx="10"/><path fill="#000" d="M6.168 16.445a1 1 0 0 0 1.664 1.11C8.99 15.819 10.354 15 12 15s3.01.819 4.168 2.555a1 1 0 1 0 1.664-1.11C16.322 14.181 14.354 13 12 13s-4.322 1.18-5.832 3.445"/></g></svg>`,
};
export const iconIconSettings: {
  name: 'icon-settings';
  data: string;
} = {
  name: 'icon-settings',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M7 3h10a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8m0 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill="#000" d="M7 13h10a4 4 0 1 1 0 8H7a4 4 0 1 1 0-8m10 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4" opacity=".3"/></g></svg>`,
};
export const iconIconShare: {
  name: 'icon-share';
  data: string;
} = {
  name: 'icon-share',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M10.9 2a1 1 0 0 1 0 2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2a1 1 0 0 1 2 0v2a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z" opacity=".3"/><path fill="#000" fill-rule="nonzero" d="M7.005 13.897c0-.762-.164-3.772 2.21-6.16 1.599-1.608 3.99-1.886 6.85-2.013V1.838a.75.75 0 0 1 1.254-.556l6.509 5.905a.75.75 0 0 1 .005 1.106l-6.508 6.027a.75.75 0 0 1-1.26-.55V9.908c-1.816.05-3.11.165-4.284.539q-2.527.803-3.912 4.55a.75.75 0 0 1-.703.49H7c0-.46.005-1.186.005-1.59"/></g></svg>`,
};
export const iconIconShuffle: {
  name: 'icon-shuffle';
  data: string;
} = {
  name: 'icon-shuffle',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M18 15v-1.523a.5.5 0 0 1 .83-.375l2.935 2.576a.5.5 0 0 1-.001.752l-2.935 2.56a.5.5 0 0 1-.829-.376V17h-1.555a6 6 0 0 1-4.736-2.316l-3.997-5.14A4 4 0 0 0 4.555 8H2V6h2.555A6 6 0 0 1 9.29 8.316l3.997 5.14A4 4 0 0 0 16.445 15z" opacity=".3"/><path fill="#000" fill-rule="nonzero" d="M18 6V4.477a.5.5 0 0 1 .83-.375l2.935 2.576a.5.5 0 0 1-.001.752l-2.935 2.56A.5.5 0 0 1 18 9.614V8h-1.555a4 4 0 0 0-3.157 1.544l-3.997 5.14A6 6 0 0 1 4.555 17H2v-2h2.555a4 4 0 0 0 3.157-1.544l3.997-5.14A6 6 0 0 1 16.445 6z"/></g></svg>`,
};
export const iconIconSkyEnglish: {
  name: 'icon-sky-english';
  data: string;
} = {
  name: 'icon-sky-english',
  data: `<svg xmlns="http://www.w3.org/2000/svg" data-name="Camada 2" viewBox="0 0 306.99 306.64"><g fill="#40A2FF"><path d="M238.74 106.28c0-21.09-17.16-38.26-38.25-38.26s-38.25 17.16-38.25 38.26 17.16 38.26 38.25 38.26 38.25-17.16 38.25-38.26m-62.5 0c0-13.38 10.88-24.26 24.25-24.26s24.25 10.88 24.25 24.26-10.88 24.26-24.25 24.26-24.25-10.88-24.25-24.26"/><path d="M306.75 19.23c0-.09-.79-9.1-2.43-12.21-2.62-4.96-8.08-5.63-11.34-6.03-.53-.07-1.39-.17-1.82-.26L289.88 0h-16.26l-.45.02c-34.82 2.44-73.39 20.18-88.35 27.7-38.52 19.34-68.72 43.75-89.78 72.54h-.55c-17.2 0-37.1 1.15-55.75 14.9C20.09 128.87 3.18 159.35.21 184.53c-.17 1.45-.11 2.75-.05 3.91.03.6.06 1.23.03 1.58L0 192.33l1.23 1.97c4.77 7.62 11.24 7.4 15.96 7.24l.43-.02 46.72-5.11c.18 4.36.74 9.2 2.93 13.22 2.19 4.04 25.38 27.23 29.54 29.55 4.3 2.4 9.49 3.04 13.76 3.26-.55 5.5-1.24 11.05-1.91 16.51-1.45 11.79-2.95 23.98-3.2 36.2l-.02 1.22.39 1.16c1.92 5.71 6.89 9.11 13.28 9.11.33 0 .67 0 1-.03 10.04-.54 27.71-7.12 34.69-10.23 35.98-15.99 54.22-45.89 51.41-84.24 33.02-24.47 60.62-60.38 79.84-103.88 8.71-19.72 22.99-57.5 20.7-89.03M191.91 209.59c1.88 17.06-.9 32.11-8.26 44.71-7.29 12.48-18.91 22.34-34.55 29.29-7.72 3.43-22.6 8.58-29.57 9.03.39-10.62 1.73-21.47 3.02-31.97.98-7.99 2-16.24 2.62-24.47l.55-7.26-7.28-.26c-.9-.03-1.85-.05-2.91-.07-4.04-.08-9.05-.17-11.74-1.54-3.4-2.52-21.7-20.8-24.33-24.3-1.12-2.34-1.18-7.05-1.23-10.84-.02-1.26-.03-2.46-.08-3.57l-.3-7.49-61.01 6.7h-.13c-1.18.05-2.05.08-2.59.05-.02-.54-.05-1.14-.02-1.41 2.48-21.07 17.55-48.43 32.91-59.75 15.71-11.58 32.62-12.35 51.5-12.14l3.68.04 2.12-3.02c19.79-28.19 48.98-52.1 86.76-71.07 29.49-14.81 60.46-24.62 82.77-26.23h12.79c1.58.51 3.19.71 4.63.89.23.03.5.06.79.1.31 1.81.64 4.22.71 5.27 2.07 28.49-11.36 63.83-19.55 82.35-18.87 42.7-45.99 77.46-78.42 100.51l-3.35 2.38.45 4.09Z"/></g></svg>`,
};
export const iconIconTicket: {
  name: 'icon-ticket';
  data: string;
} = {
  name: 'icon-ticket',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="m4.05 17.485-1.45-1.45a1 1 0 0 1 0-1.414l3.536-3.535L7.55 12.5a1 1 0 1 0 1.414-1.414L7.55 9.672 14.621 2.6a1 1 0 0 1 1.415 0l1.45 1.45a2.5 2.5 0 0 0 3.464 3.464l1.45 1.45a1 1 0 0 1 0 1.414l-7.072 7.07-1.414-1.413A1 1 0 0 0 12.5 17.45l1.414 1.414-3.535 3.535a1 1 0 0 1-1.415 0l-1.45-1.45a2.5 2.5 0 0 0-3.464-3.464m5.622-4.278a1 1 0 0 0 0 1.414l.707.707a1 1 0 0 0 1.414-1.414l-.707-.707a1 1 0 0 0-1.414 0" opacity=".3"/></g></svg>`,
};
export const iconIconTown: {
  name: 'icon-town';
  data: string;
} = {
  name: 'icon-town',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" d="M13.5 21v-3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v3H5V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v17zM9 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM9 8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm0 4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm5 0a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z"/><rect width="3" height="3" x="13" y="8" fill="#FFF" rx="1"/><path fill="#000" d="M4 21h16a1 1 0 0 1 1 1v.4a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6V22a1 1 0 0 1 1-1" opacity=".3"/></g></svg>`,
};
export const iconIconTrash: {
  name: 'icon-trash';
  data: string;
} = {
  name: 'icon-trash',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M6 8v12.5A1.5 1.5 0 0 0 7.5 22h9a1.5 1.5 0 0 0 1.5-1.5V8z"/><path fill="#000" d="M14 4.5V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.5H5.5A.5.5 0 0 0 5 5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V5a.5.5 0 0 0-.5-.5z" opacity=".3"/></g></svg>`,
};
export const iconIconTwousers: {
  name: 'icon-twousers';
  data: string;
} = {
  name: 'icon-twousers',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M18 14a3 3 0 1 1 0-6 3 3 0 0 1 0 6m-9-3a4 4 0 1 1 0-8 4 4 0 0 1 0 8" opacity=".3"/><path fill="#000" fill-rule="nonzero" d="M17.601 15c3.407.038 6.188 1.76 6.397 5.4.009.147 0 .6-.542.6H19.6c0-2.25-.744-4.328-1.999-6m-17.6 5.2C.388 15.426 4.26 13 8.983 13c4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H.727c-.25 0-.747-.54-.726-.8"/></g></svg>`,
};
export const iconIconUser: {
  name: 'icon-user';
  data: string;
} = {
  name: 'icon-user',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path fill="#000" fill-rule="nonzero" d="M12 11a4 4 0 1 1 0-8 4 4 0 0 1 0 8" opacity=".3"/><path fill="#000" fill-rule="nonzero" d="M3 20.2c.388-4.773 4.262-7.2 8.983-7.2 4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H3.727c-.25 0-.747-.54-.726-.8"/></g></svg>`,
};
export type myIcons =
  | 'icon-add'
  | 'icon-address-book'
  | 'icon-books'
  | 'icon-card'
  | 'icon-chart-line1'
  | 'icon-chat'
  | 'icon-clipboard-check'
  | 'icon-clipboard'
  | 'icon-clipboard2'
  | 'icon-clock'
  | 'icon-credit-card'
  | 'icon-edit'
  | 'icon-error-circle'
  | 'icon-folder'
  | 'icon-happy'
  | 'icon-heart'
  | 'icon-important'
  | 'icon-info'
  | 'icon-mirror'
  | 'icon-paper-error'
  | 'icon-question-circle'
  | 'icon-question'
  | 'icon-report'
  | 'icon-return'
  | 'icon-sad'
  | 'icon-settings'
  | 'icon-share'
  | 'icon-shuffle'
  | 'icon-sky-english'
  | 'icon-ticket'
  | 'icon-town'
  | 'icon-trash'
  | 'icon-twousers'
  | 'icon-user';
export interface MyIcon {
  name: myIcons;
  data: string;
}
export type MyIconNameSubset<T extends Readonly<MyIcon[]>> = T[number]['name'];
export const completeIconSet = [
  iconIconAdd,
  iconIconAddressBook,
  iconIconBooks,
  iconIconCard,
  iconIconChartLine1,
  iconIconChat,
  iconIconClipboardCheck,
  iconIconClipboard,
  iconIconClipboard2,
  iconIconClock,
  iconIconCreditCard,
  iconIconEdit,
  iconIconErrorCircle,
  iconIconFolder,
  iconIconHappy,
  iconIconHeart,
  iconIconImportant,
  iconIconInfo,
  iconIconMirror,
  iconIconPaperError,
  iconIconQuestionCircle,
  iconIconQuestion,
  iconIconReport,
  iconIconReturn,
  iconIconSad,
  iconIconSettings,
  iconIconShare,
  iconIconShuffle,
  iconIconSkyEnglish,
  iconIconTicket,
  iconIconTown,
  iconIconTrash,
  iconIconTwousers,
  iconIconUser,
];
